/**
 * @file   http
 * @create wangdekui 2020/09/27
 * @update
 */
import axios from "axios";
import CryptoJS from "crypto-js";

const ENV_API = window.ENV_API;
export const CMSGATEWAY = window.ENV_CMS;
export const FILEGATEWAY = "sw-file-cloud";
export const SEARCHGATEWAY = "sw-es";
export const appId = "d780b81452d94d598ddb73b14789f7af";
const appKey = "09BLNZN0RX852GSGV5YWQXHKAIFRJ488";
// // AES加密
function encrypt(key) {
  const r = Math.random();
  const randomSix = ("" + r).split(".")[1].slice(0, 6);
  const text = randomSix + +new Date();
  const encrypt = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypt.toString();
}

export const http = axios.create({ baseURL: ENV_API });
http.interceptors.request.use((config) => {
  config.headers["appId"] = appId;
  config.headers["token"] = encrypt(appKey);
  return config;
});
